import request from "@/utils/request";


// 获取时间设置
export function getTimeApi(data) {
    return request({
      url: "/admin/get_config_setting",
      method: "get",
      params: data
    });
  }

// 设置时间
export function setTimeApi(data) {
    return request({
      url: "/admin/set_config_setting",
      method: "post",
      data
    });
  }
